import { render } from "./Record.vue?vue&type=template&id=57986b7b&scoped=true"
import script from "./Record.vue?vue&type=script&lang=js"
export * from "./Record.vue?vue&type=script&lang=js"

import "./Record.vue?vue&type=style&index=0&id=57986b7b&scoped=true&lang=css"

import exportComponent from "E:\\WebstormProjects\\sms-transfer-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57986b7b"]])

export default __exports__